import { useTranslation } from 'react-i18next';

export default function DashboardButton({ DashboardMenu, item }: any) {
    const { t } = useTranslation();

    return (
        <div>
            <div className="mb-3 ">

                <div style={{ backgroundImage: 'url(/walls.jpg)' }} className="w-full text-[20px] h-[100px] rounded-lg shadow mb-4 text-white flex pr-5 justify-self-end items-center bg-white ">
                    {t(DashboardMenu.find((items: any) => items.name === item)?.name)}
                </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 ">
                {
                    DashboardMenu.map((i: any) => {

                        return (
                            i.name == item &&
                            i.sub.map((p: any) => {
                                return (
                                    <a href={p.url} className="">
                                        <div className="bg-slate-400 hover:bg-slate-300 shadow-stone-800   border-b-4 text-[13px] font-bold  w-[100%] h-[100px] text-center pt-4 ">
                                            <div className="pl-3 pr-3 text-end h-[50px]">
                                                <img src={p.icon} width={30}></img>
                                            </div>
                                            <div className="p-4 directions d pl-3 pr-3 text-start bg-gray-700 text-white" >
                                                {t(p.name)}
                                            </div>
                                        </div>
                                    </a>
                                )
                            })
                        )

                    })
                }
            </div>
        </div>
    )
}